import { CATEGORIES_PATH } from '@/_constants/routes';

const ROUTES_WITH_SOCIALS = [CATEGORIES_PATH];

export const getIsPathWithSocials = (pathname: string): boolean =>
  ROUTES_WITH_SOCIALS.some((route) => pathname.includes(route));
